import { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CircularProgress, Alert, Box, Link, Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import VisibilityOffTwoToneIcon from '@mui/icons-material/VisibilityOffTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { authContext } from '../../../routes';
import { USERNAME_REGEX } from '../../../utils/constants';
import axiosInstance from '../../../api';
import SERVER_API_URL from '../../../config';
import CustomButton from '../../../components/custom-button/CustomButton';

export default function LoginForm() {
  const [error, setError] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const { handleLogin } = useContext(authContext);
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIsLoggedIn = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/auth/getme`);
        if (response.status === 200) {
          navigate('/dashboard');
        }
      } catch (error) {
        // console.log(error)
      }
    };

    checkIsLoggedIn();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);

    const data = new FormData(e.currentTarget);
    if (!USERNAME_REGEX.test(data.get('username'))) {
      setError('የተሳሳተ የተጠቃሚ ስም አድራሻ');
      setDisabled(false);
      return;
    }
    if (data.get('password').length < 8) {
      setError('የይለፍ ቃል ቢያንስ 8 ቁምፊዎች መሆን አለበት።');
      setDisabled(false);
      return;
    }

    try {
      const jsonData = Object.fromEntries(data.entries());
      const response = await axios.post(`${SERVER_API_URL}/auth/signin`, jsonData);
      if (response.status === 202) {
        localStorage.setItem('id', response.data.id);
        localStorage.setItem('token', response.data.token);
        handleLogin();
        setError(null);
      }
    } catch (e) {
      if (e.code === 'ERR_NETWORK') {
        setError('የኔትወርክ ችግር አለ። እባክዎ ትንሽ ቆይተው ይሞክሩ!');
      } else if (e.response && e.response.status === 404) {
        setError('ከዚህ የተጠቃሚ ስም አድራሻ ጋር የተገናኘ ምንም መለያ የለም።');
      } else if ((e.response && e.response.status === 401) || (e.response && e.response.status === 400)) {
        setError('ልክ ያልሆነ የተጠቃሚ ስም ወይም የይለፍ ቃል');
      } else if (e.response && e.response.status === 406) {
        setError('ይህ ተጠቃሚ ታግዷል !');
      } else if(e.response && e.response.status === 429){
        setError('ከተፈቀደው ገደብ በላይ ሞክረዋል ፣ እባክዎ ክ1 ሰአት በኋላ እንደገና ይሞክሩ።');
      } else {
        setError('ያልታወቀ ስህተት ተከስቷል። እባክዎ ዳግም ይሞክሩ!');
      }
    }
    setDisabled(false);
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={3} sx={{ my: 2 }}>
        {error && (
          <Alert sx={{ width: '100%' }} severity="error">
            {error}
          </Alert>
        )}

        <TextField id="username" variant="outlined" name="username" label="የተጠቃሚ ስም" placeholder="የተጠቃሚ ስም" required />

        <TextField
          id="password"
          name="password"
          label="የይለፍ ቃል"
          placeholder="የይለፍ ቃል"
          type={showPassword ? 'text' : 'password'}
          required
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityTwoToneIcon /> : <VisibilityOffTwoToneIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <CustomButton fullWidth size="large" type="submit" variant="contained" disabled={disabled}>
        {!disabled && <>ግባ</>}
        {disabled && (
          <>
            <CircularProgress style={{ width: '20px', height: '20px' }} />  ግባ...
          </>
        )}
      </CustomButton>

      <Stack direction="row" justifyContent="right" sx={{ mt: 2 }}>
        <Link
          onClick={() => navigate('/forgetPassword')}
          sx={{ cursor: 'pointer' }}
          variant="subtitle2"
          underline="hover"
        >
          መክፈቻ ቁልፉን ረሳኽው?
        </Link>
      </Stack>
    </Box>
  );
}
